import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Col, Row, Drawer, Tabs, Descriptions, List, Skeleton } from 'antd';
//Components
import Wait4Me from '../../../components/Wait4Me';
import BreadCrumb from '../../../components/BreadCrumb';
import NoDataToDisplay from '../../../components/NoDataToDisplay';
import WatchAndWhitelistTable from '../../../components/ns/WatchAndWhitelistTable';

import style from './index.scss';

const { TabPane } = Tabs;

const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 250px;
`;

export const WatchList = (props) => {
  const { apiActions, settings, watchListData } = props;

  const {
    getNSGlobalSettingsPageInfo,
    getNSRIWatchListInitiate,
    getNSRIWatchListCoverageReportsInitiate
  } = apiActions;

  const urlParams = new URLSearchParams(window.location.search);

  const [visible, setVisible] = useState(false);
  const [drawerRecord, setDrawerRecord] = useState({});
  const [activeTab, setActiveTab] = useState(urlParams.get('tab') || '1');

  useEffect(() => {
    getNSGlobalSettingsPageInfo({ pageId: 'NS_IAD_WATCHLISTS' });
    getNSRIWatchListInitiate();
  }, []);

  const showDrawer = (record) => {
    setDrawerRecord(record);
    setVisible(true);
    getNSRIWatchListCoverageReportsInitiate({ id: record?.id });
  };
  const onClose = () => {
    const activeTab = '1';
    setActiveTab(activeTab);
    setVisible(false);
  };

  const onChangeTabHandler = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  // To Get Global Settings Configuration
  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  // Global Settings config
  const GS = getGSConfig({
    widgetGroupId: 'NS_IAD_LIST_WATCHLISTS',
    widgetId: 'NS_IAD_LIST_WATCHLISTS'
  });

  const percentage = (changedValue, totalValue) => {
    if (!changedValue || !totalValue) {
      return '-';
    } else {
      return `${((100 * changedValue) / totalValue).toFixed(2)}%`;
    }
  };

  const renderCoverageTabs = (coverage) => {
    if (coverage?.length > 0)
      return (
        <Descriptions
          column={1}
          size="middle"
          bordered
          labelStyle={{
            background: 'none',
            fontSize: '10px',
            lineHeight: '12px',
            width: '70%',
            paddingLeft: '8px'
          }}
          contentStyle={{
            fontSize: '10px',
            lineHeight: '12px',
            width: '30%',
            paddingLeft: '8px'
          }}>
          {coverage?.map((item, index) => (
            <Descriptions.Item label={item?.category} key={index}>
              {item?.recordCount?.toLocaleString('en-US')
                ? item?.recordCount?.toLocaleString('en-US')
                : '-'}
            </Descriptions.Item>
          ))}
        </Descriptions>
      );
    else return <NoDataToDisplay />;
  };

  const renderReportTabs = (report) => {
    if (report?.length > 0)
      return (
        <React.Fragment>
          <List className="report-head-list">
            <List.Item>
              <List.Item.Meta title={''} />
              {report?.map((item, index) => (
                <div key={index} className={'list_value'}>
                  {item?.moduleType}
                </div>
              ))}
            </List.Item>
          </List>
          <List className="report-list" itemLayout="horizontal">
            <List.Item>
              <List.Item.Meta title={'No. of Run Instances using Watchlist'} />
              {report?.map((item, index) => (
                <div key={index} className={'list_value'}>
                  {item?.runInstanceCount}
                </div>
              ))}
            </List.Item>
            {/* <List.Item>
            <List.Item.Meta title={'No. of Hits Generated'} />
            {reportDummy.map((item, index) => (
              <div key={index} className={"list_value"}>{item?.hitCount ? item?.hitCount : "--"}</div>
            ))}
          </List.Item> */}
          </List>
        </React.Fragment>
      );
    else return <NoDataToDisplay />;
  };

  const renderRecentTabs = () => {
    return (
      <Descriptions
        column={1}
        size="middle"
        bordered
        labelStyle={{
          background: 'none',
          fontSize: '10px',
          lineHeight: '12px',
          width: '50%',
          paddingLeft: '8px'
        }}
        contentStyle={{
          fontSize: '10px',
          lineHeight: '12px',
          width: '50%',
          paddingLeft: '8px'
        }}>
        <Descriptions.Item label="New Records">
          {drawerRecord['recordsAdded']?.toLocaleString('en-US')
            ? drawerRecord['recordsAdded']?.toLocaleString('en-US')
            : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Changed Records">
          {drawerRecord['recordsChanged']?.toLocaleString('en-US')
            ? drawerRecord['recordsChanged']?.toLocaleString('en-US')
            : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Total Records">
          {drawerRecord['recordCount']?.toLocaleString('en-US')
            ? drawerRecord['recordCount']?.toLocaleString('en-US')
            : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Deleted Records">
          {drawerRecord['recordsDeleted']?.toLocaleString('en-US')
            ? drawerRecord['recordsDeleted']?.toLocaleString('en-US')
            : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Percentage(%) of Change">
          {percentage(
            drawerRecord['recordsChanged'],
            drawerRecord['recordCount']
          )}
        </Descriptions.Item>
      </Descriptions>
    );
  };

  const renderLoadingBlock = () => (
    <LoadingWrapper>
      <Wait4Me />
    </LoadingWrapper>
  );

  return (
    <>
      <Row>
        <Col span={24}>
          <div className={style.watchlist_wrapper}>
            <div className={style.head}>
              <BreadCrumb crumbs={[{ label: 'Watchlist' }]} />
              <div className={style.head_content}>
                <h4>Watchlist</h4>
              </div>
            </div>
            <div className={style.tableContent}>
              <h4>Watchlist</h4>
              <div className={style.table}>
                {settings?.nsSetting?.isLoading ? (
                  renderLoadingBlock()
                ) : (
                  <WatchAndWhitelistTable
                    {...props}
                    GS={GS}
                    tableData={{
                      isLoading: watchListData.isLoading,
                      data: watchListData.data
                    }}
                    hasRowSelection={false}
                    hasPagination={true}
                    component="watchlist"
                    showDrawer={showDrawer}
                  />
                )}
              </div>
            </div>
            <Drawer
              title={`${drawerRecord?.id} ${drawerRecord?.name}`}
              placement="right"
              width={364}
              height={866}
              closable={true}
              onClose={onClose}
              visible={visible}
              className={style.watchlist_drawer}>
              <Tabs
                activeKey={activeTab}
                className={style.tab}
                onChange={onChangeTabHandler}>
                <TabPane tab="Recent Changes" id="recentChanges" key="1">
                  {renderRecentTabs()}
                </TabPane>
                <TabPane tab="Coverage" id="tabCoverage" key="2">
                  {watchListData?.watchListCoverageReport?.isLoading
                    ? renderLoadingBlock()
                    : renderCoverageTabs(
                        watchListData?.watchListCoverageReport?.data?.coverage
                      )}
                </TabPane>
                <TabPane tab="Report" id="tabReport" key="3">
                  {watchListData?.watchListCoverageReport?.isLoading
                    ? renderLoadingBlock()
                    : renderReportTabs(
                        watchListData?.watchListCoverageReport?.data?.report
                      )}
                </TabPane>
              </Tabs>
            </Drawer>
          </div>
        </Col>
      </Row>
    </>
  );
};

WatchList.propTypes = {
  apiActions: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  watchListData: PropTypes.object
};

export default WatchList;
